/* eslint-disable react-hooks/exhaustive-deps */
import React, { Suspense, useEffect, useState } from "react";
import {
  Route,
  Routes,
  Navigate,
  useNavigate,
  useLocation,
} from "react-router-dom";
import { FallingLines } from "react-loader-spinner";
import LoginPage from "pages/login";
import SignupPage from "pages/signup";
import ForgetPassword from "pages/forgetPassword";
import SetPassword from "pages/setPassword";
import AgencyTeam from "pages/agencyTeam";
import UpdatePassword from "pages/updatePassword";
import FooterComponent from "components/footer";
import GuardRoute from "./guardRoute";
import {
  VM_PORTAL_COOKIE_NAME,
  publicRoutes,
  exposedRoutePages,
} from "utils/constantValues";
import useCheckUser from "hooks/useCheckUser";
import Cookie from "components/cookie";
import { getCookie } from "utils/getCookie";
import InviteAssignees from "pages/externalPage/inviteAssignees";
import ConfirmPOAssignee from "pages/externalPage/confirmPOAssignee";
import ConfirmRequestPayment from "pages/externalPage/confirmRequestPayment";
import ConfirmFinanceGroupedInvoice from "pages/externalPage/confirmfinanceGroupedInvoice";
import UserDetails from "pages/userDetails";
import ServicesPage from "pages/services";
import ProjectsPage from "pages/projects";
import DocumentsPage from "pages/documents";
import Earnings from "pages/earnings";
import InvoicesPage from "pages/invoices";
import FinancialDetailsPage from "pages/financialDetails";

const Loading = () => {
  return (
    <div className="flex items-center justify-center h-screen w-full">
      <FallingLines
        color="#023A66"
        width="100%"
        visible={true}
        ariaLabel="falling-lines-loading"
      />
    </div>
  );
};

function AppRouters() {
  const [isAcceptedCookie, setIsAcceptCookie] = useState(
    getCookie(VM_PORTAL_COOKIE_NAME)
  );

  const { isChecked, isAuth } = useCheckUser();
  const location = useLocation().pathname;

  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
    if (isAuth && publicRoutes.includes(location.split("/")[1])) {
      navigate("/");
    }
  }, [isChecked]);

  if (!isChecked) {
    return <Loading />;
  }

  return (
    <Suspense fallback={<Loading />}>
      <div className="flex flex-col min-h-screen">
        <Routes>
          <Route exact path="/set-password/:token" element={<SetPassword />} />
          <Route exact path="/forget-password" element={<ForgetPassword />} />
          <Route path="/signup" element={<SignupPage />} />
          <Route path="/signup/:accountType" element={<SignupPage />} />
          <Route exact path="/login" element={<LoginPage />} />

          <Route
            exact
            path="/teams"
            element={
              <GuardRoute>
                <AgencyTeam />
              </GuardRoute>
            }
          />

          <Route
            exact
            path="/update-password"
            element={
              <GuardRoute>
                <UpdatePassword />
              </GuardRoute>
            }
          />

          <Route
            exact
            path="/order/invitePendingAssignees/:token/:slug"
            element={<InviteAssignees />}
          />

          <Route
            exact
            path="/order/respondPurchaseOrder/:token"
            element={<ConfirmPOAssignee />}
          />

          <Route
            exact
            path="/order/requestPayment/:token"
            element={<ConfirmRequestPayment />}
          />
          <Route
            exact
            path="/finance/groupedInvoice/:token"
            element={<ConfirmFinanceGroupedInvoice />}
          />
          <Route
            exact
            path="/finance/project/:token"
            element={<ConfirmFinanceGroupedInvoice />}
          />

          <Route
            exact
            path="/team-members"
            element={
              <GuardRoute>
                <AgencyTeam />
              </GuardRoute>
            }
          />

          <Route
            exact
            path="/services"
            element={
              <GuardRoute>
                <ServicesPage />
              </GuardRoute>
            }
          />
          <Route
            exact
            path="/projects"
            element={
              <GuardRoute>
                <ProjectsPage />
              </GuardRoute>
            }
          />
          <Route
            exact
            path="/documents"
            element={
              <GuardRoute>
                <DocumentsPage />
              </GuardRoute>
            }
          />
          {/* <Route
            exact
            path="/earnings"
            element={
              <GuardRoute>
                <Earnings />
              </GuardRoute>
            }
          /> */}

          {/* <Route
            exact
            path="/invoices"
            element={
              <GuardRoute>
                <InvoicesPage />
              </GuardRoute>
            }
          /> */}
          <Route
            exact
            path="/financial-details"
            element={
              <GuardRoute>
                <FinancialDetailsPage />
              </GuardRoute>
            }
          />

          <Route
            exact
            path="/"
            element={
              <GuardRoute>
                <UserDetails />
              </GuardRoute>
            }
          />
          <Route exact path={"*"} element={<Navigate replace to="/" />} />
        </Routes>

        <FooterComponent />
        {!isAcceptedCookie && <Cookie setIsAcceptCookie={setIsAcceptCookie} />}
      </div>
    </Suspense>
  );
}

export default AppRouters;
